export const DEFAULT_WORK_HOUR_TEMPLATE = {
  timezone: 'UTC',
  hourTypes: [
    { slug: 'ordinary', label: 'Ordinary time', sortOrder: 0 },
    { slug: 'overtime', label: 'Overtime', sortOrder: 1 },
    { slug: 'unusual', label: 'Unusual hours', sortOrder: 2 },
    { slug: 'jour', label: 'On-call (jour)', sortOrder: 3 }
  ],
  rules: [
    {
      hourTypeSlug: 'ordinary',
      weekdays: [1, 2, 3, 4, 5],
      startTime: '07:00',
      endTime: '18:00',
      sortOrder: 0
    },
    {
      hourTypeSlug: 'overtime',
      weekdays: [1, 2, 3, 4, 5],
      startTime: '18:00',
      endTime: '23:59',
      sortOrder: 1
    },
    {
      hourTypeSlug: 'unusual',
      weekdays: [0, 6],
      startTime: '00:00',
      endTime: '23:59',
      sortOrder: 2
    }
  ]
};

export const WEEKDAY_OPTIONS = [
  { value: 0, label: 'Sun' },
  { value: 1, label: 'Mon' },
  { value: 2, label: 'Tue' },
  { value: 3, label: 'Wed' },
  { value: 4, label: 'Thu' },
  { value: 5, label: 'Fri' },
  { value: 6, label: 'Sat' }
];

export const slugifyHourType = (label) =>
  String(label || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 40) || 'hour_type';

export const normalizeRuleTimes = (rules) =>
  rules.map((rule) => ({
    ...rule,
    startTime: String(rule.startTime || '').slice(0, 5),
    endTime: normalizeEndTimeForInput(rule.endTime)
  }));

export const normalizeEndTimeForInput = (value) => {
  const text = String(value || '');
  if (text.startsWith('23:59:59') || text.startsWith('23:59')) {
    return '23:59';
  }
  return text.slice(0, 5);
};

export const formatEndTimeForSave = (value) => {
  const text = String(value || '').slice(0, 5);
  if (text === '23:59') {
    return '23:59:59';
  }
  return text;
};

export const mapApiToForm = (data) => ({
  timezone: data.timezone || DEFAULT_WORK_HOUR_TEMPLATE.timezone,
  hourTypes: (data.hourTypes || []).map((type, index) => ({
    slug: type.slug,
    label: type.label,
    sortOrder: Number.isInteger(type.sortOrder) ? type.sortOrder : index,
    slugLocked: true
  })),
  rules: normalizeRuleTimes(
    (data.rules || []).map((rule, index) => ({
      hourTypeSlug: rule.hourTypeSlug,
      weekdays: Array.isArray(rule.weekdays) ? [...rule.weekdays] : [],
      startTime: rule.startTime,
      endTime: rule.endTime,
      sortOrder: Number.isInteger(rule.sortOrder) ? rule.sortOrder : index
    }))
  )
});

export const buildSavePayload = (form) => ({
  timezone: form.timezone.trim(),
  hourTypes: form.hourTypes.map((type, index) => ({
    slug: type.slug,
    label: type.label.trim(),
    sortOrder: index
  })),
  rules: form.rules.map((rule, index) => ({
    hourTypeSlug: rule.hourTypeSlug,
    weekdays: [...rule.weekdays].sort((a, b) => a - b),
    startTime: rule.startTime,
    endTime: formatEndTimeForSave(rule.endTime),
    sortOrder: index
  }))
});
